export const WETNOTES_TITLE = 'Wetnotes';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/wetnotes.ts